import { http } from '../../config/axios'

export default function putFranquia(franquia: any): Promise<string> {
  return http
    .put('api/franquia', franquia)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put franquia', error)
      throw Error(error.response.data)
    })
}
